import React from 'react';
import DocumentMeta from 'react-document-meta';

class TermsConditions extends React.Component {
	render() {
		const meta = {
			title: 'Handelsbetingelser – Alaska Cykler',
			description: 'Salgs-, leverings- og reparationsbetingelser for Alaska Cykler i Brønshøj. Læs om betaling, afhentning, fortrydelsesret og reklamation.',
			canonical: window.location.href,
			meta: {
				charset: 'utf-8',
				name: {
					keywords: 'alaska cykler handelsbetingelser, salgsbetingelser, leveringsbetingelser, værkstedsvilkår, cykeludlejning, reklamationsret'
				}
			}
		};

		return (
			<div className="main-content" id="policy-page">
				<DocumentMeta {...meta} />

				<div className="container policy-container">
					<header className="header header-main text-left row">
						<h2 className="col-md-12 text-left">
							Handelsbetingelser
							<p>Salgs-, leverings- og værkstedsbetingelser – Alaska Cykler</p>
						</h2>
					</header>

					<div className="row">
						<div className="col-md-10">
							<p className="policy-meta"><strong>Senest opdateret:</strong> 22. oktober 2026</p>

							<p>
								Velkommen til Alaska Cykler. Nedenfor finder du vores handels- og leveringsbetingelser, som gælder for alle handler, reparationer og udlejningsaftaler indgået med Alaska Cykler – uanset om aftalen indgås i vores fysiske butik eller via telefon, e-mail eller vores hjemmeside.
							</p>

							<h3 className="sec-head">1. Virksomhedsoplysninger</h3>
							<p>
								Handelsbetingelserne er gældende for aftaler indgået med:
							</p>
							<ul>
								<li><strong>Virksomhed:</strong> Alaska Cykler</li>
								<li><strong>CVR-nr.:</strong> 38971069</li>
								<li><strong>Adresse:</strong> Islevhusvej 7, 2700 Brønshøj</li>
								<li><strong>Telefon:</strong> <a href="tel:+4571873167">71 87 31 67</a></li>
								<li><strong>E-mail:</strong> <a href="mailto:alaskacykler@mail.com">alaskacykler@mail.com</a></li>
							</ul>

							<h3 className="sec-head">2. Aftaleindgåelse og bestilling</h3>
							<p>
								Når du handler hos Alaska Cykler, indgås alle aftaler på dansk.
							</p>
							<p>
								Ved køb i butikken indgås en bindende aftale, når varen eller ydelsen betales, eller når der udstedes en kvittering eller faktura. Ved forespørgsler eller bestillinger via telefon, e-mail eller kontaktformular fremsender vi en bekræftelse. Aftalen anses først for bindende indgået, når vi har bekræftet ordren eller reservationen over for dig.
							</p>
							<p>
								Vi forbeholder os retten til at afvise ordrer i tilfælde af åbenlyse pris- eller tastefejl, udsolgte varer eller uforudsete leveringsvanskeligheder.
							</p>

							<h3 className="sec-head">3. Priser og betaling</h3>
							<p>
								Alle priser på hjemmesiden og i butikken er angivet i danske kroner (DKK) og er inklusive 25 % dansk moms samt eventuelle lovpligtige afgifter.
							</p>
							<p>
								I vores butik på Islevhusvej modtager vi følgende betalingsmidler:
							</p>
							<ul>
								<li>Kontant betaling</li>
								<li>Dankort, Visa, Visa Electron, Mastercard og Maestro</li>
								<li>MobilePay</li>
							</ul>
							<p>
								Ved specialbestillinger af cykler eller reservedele, som ikke er på lager, kan der opkræves et forudgående acontobeløb eller depositum. Dette oplyses altid inden ordren endeligt igangsættes.
							</p>

							<h3 className="sec-head">4. Afhentning og levering</h3>
							<p>
								<strong>Afhentning i butikken:</strong> Alle købte cykler, tilbehør og færdigreparerede cykler kan vederlagsfrit afhentes i vores butik på Islevhusvej 7, 2700 Brønshøj inden for vores normale åbningstider. Cykler udleveres altid færdigsamlede, justerede og 100 % køreklare.
							</p>
							<p>
								<strong>Levering efter aftale:</strong> Vi tilbyder lokal levering af klargjorte cykler og større reservedele i Storkøbenhavn og omegn efter forudgående aftale. Fragt- og leveringsomkostninger samt det forventede leveringstidspunkt oplyses og godkendes altid af kunden inden bekræftelse.
							</p>
							<p>
								Risikoen for varen overgår til dig som kunde i det øjeblik, varen udleveres i butikken eller modtages på den aftalte leveringsadresse.
							</p>

							<h3 className="sec-head">5. Fortrydelsesret ved fjernsalg</h3>
							<p>
								I overensstemmelse med forbrugeraftalelovens regler gælder der 14 dages fortrydelsesret for privatkunder ved køb foretaget som fjernsalg (dvs. køb foretaget udelukkende via hjemmeside, e-mail eller telefon uden fysisk fremmøde i butikken).
							</p>
							<p>
								Fortrydelsesfristen udløber 14 dage efter den dag, hvor du:
							</p>
							<ul>
								<li>Har modtaget varen i fysisk besiddelse.</li>
								<li>Får den sidste vare i fysisk besiddelse ved en aftale om flere forskellige varer, som er bestilt i én ordre og leveres enkeltvis.</li>
							</ul>
							<p>
								<strong>Sådan fortryder du:</strong> Du skal inden for 14-dages fristen give os en utvetydig skriftlig meddelelse pr. e-mail til <a href="mailto:alaskacykler@mail.com">alaskacykler@mail.com</a> om, at du ønsker at udnytte din fortrydelsesret.
							</p>
							<p>
								<strong>Returnering af varen:</strong> Du skal returnere varen til os uden unødig forsinkelse og senest 14 dage efter den dato, hvor du har meddelt os, at du vil fortryde købet. Udgifter til returnering påhviler kunden.
							</p>
							<p>
								<strong>Varens stand ved returnering:</strong> Du hæfter kun for eventuel forringelse af varens værdi, som skyldes anden håndtering, end hvad der er nødvendigt for at fastslå varens art, egenskaber og den måde, den fungerer på. Hvis en cykel eller et stykke udstyr er taget i brug ud over almindelig afprøvning (f.eks. udendørs kørsel med slid og snavs), betragtes varen som brugt, og du vil ved fortrydelse få en del eller intet af købsbeløbet retur afhængigt af den handelsmæssige værdiforringelse.
							</p>
							<p>
								<strong>Undtagelser fra fortrydelsesretten:</strong> Fortrydelsesretten bortfalder ved levering af varer, der er fremstillet efter forbrugerens specifikationer eller har fået et tydeligt personligt præg (f.eks. specialbyggede cykler eller specialbestilte lakeringer), samt reparationsydelser, hvor reparationen er fuldført efter kundens forudgående udtrykkelige samtykke.
							</p>
							<p>
								<em>Bemærk:</em> Ved almindelige køb foretaget i vores fysiske butik på Islevhusvej ydes der ikke automatisk fortrydelsesret, medmindre andet er udtrykkeligt aftalt forud for købet.
							</p>

							<h3 className="sec-head">6. Reklamationsret og garanti (Købeloven)</h3>
							<p>
								Købelovens mangelsregler finder anvendelse på alle varekøb hos Alaska Cykler. Som privat forbruger har du 24 måneders lovpligtig reklamationsret.
							</p>
							<p>
								Reklamationsretten betyder, at du ved fabrikations-, materiale- eller samlingsfejl kan få varen repareret, ombyttet, pengene tilbage eller et afslag i prisen, afhængigt af den konkrete situation. Reklamationsretten dækker oprindelige fejl, der var til stede på købstidspunktet.
							</p>
							<p>
								<strong>Hvad dækker reklamationsretten ikke?</strong>
							</p>
							<ul>
								<li>Almindeligt slid på sliddele som dæk, slanger, bremseklodser, kæder, tandhjul, kabler, lygtepærer og håndtag.</li>
								<li>Skader forårsaget af forkert betjening, overbelastning, mangelfuld eller forkert vedligeholdelse (herunder manglende oliering og forkert dæktryk).</li>
								<li>Skader opstået som følge af styrt, påkørsler, hærværk eller uautoriseret indgreb på cyklen eller dens elektriske komponenter.</li>
							</ul>
							<p>
								<strong>Reklamationsfrist:</strong> Du skal reklamere inden for ”rimelig tid” efter, at du har opdaget manglen. Reklamerer du inden for to måneder efter, at manglen er opdaget, vil reklamationen altid anses for rettidig. Medbring venligst købskvittering eller faktura ved henvendelse.
							</p>
							<p>
								Eventuelle fabriksgarantier fra cykel- eller komponentproducenter (f.eks. udvidet stelgaranti) ydes som et supplement og indskrænker ikke forbrugerens lovbestemte rettigheder efter købeloven.
							</p>

							<h3 className="sec-head">7. Værksted og reparationsvilkår</h3>
							<p>
								Hos Alaska Cykler har vi mere end 15 års erfaring med professionel reparation, klargøring og serviceeftersyn af alle typer cykler.
							</p>
							<p>
								<strong>Prisoverslag:</strong> Ved indlevering af en cykel aftaler vi det ønskede arbejde og udsteder så vidt muligt et vejledende prisoverslag.
							</p>
							<p>
								<strong>Uforudset merarbejde:</strong> Viser det sig under adskillelse eller reparation, at der er yderligere defekter, som gør reparationen dyrere end aftalt, kontakter vi dig telefonisk eller via SMS for din accept, forud for at merarbejdet udføres.
							</p>
							<p>
								<strong>Afhentningsfrist for reparerede cykler:</strong> Når din cykel er færdigmeldt via SMS eller telefon, bedes du afhente den hurtigst muligt og senest 14 dage efter færdiggørelse. Hvis en cykel ikke afhentes inden for 3 måneder trods gentagne henvendelser, forbeholder vi os ret til at bortsælge cyklen til dækning af værkstedets udlæg i henhold til gældende retsregler (lov om erhvervsdrivendes ret til at sælge varer, der ikke er afhentet).
							</p>

							<h3 className="sec-head">8. Særlige vilkår for cykeludlejning</h3>
							<p>
								Ved leje af cykler hos Alaska Cykler gælder følgende særlige betingelser:
							</p>
							<ul>
								<li><strong>Legitimation:</strong> Lejer skal ved udlevering fremvise gyldigt billed-ID (pas, kørekort eller nationalt ID-kort) samt oplyse bopælsadresse og telefonnummer.</li>
								<li><strong>Ansvar og brug:</strong> Lejer har det fulde ansvar for cyklen, låsen og eventuelt udstyr i hele lejeperioden, indtil cyklen er behørigt afleveret tilbage i butikken. Cyklen må kun benyttes til normal, forsvarlig cykelkørsel på offentlig vej og cykelsti.</li>
								<li><strong>Tyveri og beskadigelse:</strong> Lejer hæfter fuldt ud for skader, der overstiger almindeligt slid, samt ved bortkomst eller tyveri. Cyklen skal altid låses med den medfølgende godkendte lås, når den efterlades. I tilfælde af tyveri skal lejer straks anmelde forholdet til politiet og aflevere politianmeldelse samt cykelnøgler til Alaska Cykler.</li>
								<li><strong>Returnering:</strong> Cyklen skal afleveres i rengjort og funktionsdygtig stand senest på det aftalte tidspunkt. Ved forsinket returnering opkræves yderligere leje for den overskredne periode.</li>
							</ul>

							<h3 className="sec-head">9. Forbehold og ansvarsbegrænsning</h3>
							<p>
								Alaska Cykler tager forbehold for tryk- og tastefejl, prisændringer, udsolgte varer, specifikationsændringer fra producenter samt tekniske fejl på hjemmesiden.
							</p>
							<p>
								Vi er ikke ansvarlige for forsinkelser eller mangler, som skyldes forhold uden for vores kontrol (force majeure), herunder lockout, strejke, brand, oversvømmelse, epidemier, krig samt forsinkelser fra underleverandører eller fragtfirmaer.
							</p>
							<p>
								Alaska Cykler påtager sig intet erstatningsansvar for indirekte tab, driftstab, tabt arbejdsfortjeneste eller avancetab som følge af mangler eller forsinkelser ved det solgte eller reparerede, medmindre andet følger af ufravigelig dansk ret.
							</p>

							<h3 className="sec-head">10. Klageadgang</h3>
							<p>
								Hvis du som kunde er utilfreds med en vare, en udført reparation eller vores service, beder vi dig altid kontakte os direkte på <a href="mailto:alaskacykler@mail.com">alaskacykler@mail.com</a> eller telefon <a href="tel:+4571873167">71 87 31 67</a>. Vi lægger stor vægt på personlig kundeservice og finder i langt de fleste tilfælde en hurtig og god løsning.
							</p>
							<p>
								Hvis det mod forventning ikke lykkes at finde en tilfredsstillende løsning sammen, har du som forbruger ret til at indgive en klage til:
							</p>
							<p>
								<strong>Center for Klageløsning / Nævnenes Hus</strong><br />
								Toldboden 2<br />
								8800 Viborg<br />
								Hjemmeside: <a href="https://naevneneshus.dk" target="_blank" rel="noopener noreferrer">www.naevneneshus.dk</a>
							</p>
							<p>
								Hvis du er forbruger med bopæl i et andet EU-land end Danmark, kan du anvende Europa-Kommissionens online klageportal (ODR):
							</p>
							<p>
								<a href="http://ec.europa.eu/odr" target="_blank" rel="noopener noreferrer">http://ec.europa.eu/odr</a>
							</p>

							<h3 className="sec-head">11. Lovvalg og værneting</h3>
							<p>
								Enhver aftale indgået med Alaska Cykler er underlagt dansk ret. Enhver tvist, som måtte opstå i forbindelse med disse handelsbetingelser, skal afgøres ved de almindelige danske domstole ved Alaska Cyklers værneting, medmindre ufravigelig forbrugerbeskyttelseslovgivning foreskriver andet.
							</p>

							<h3 className="sec-head">12. Kontakt os</h3>
							<p>
								Hvis du har spørgsmål til vores handelsbetingelser, er du altid velkommen til at henvende dig i butikken eller kontakte os:
							</p>
							<p>
								<strong>Alaska Cykler</strong><br />
								Islevhusvej 7, 2700 Brønshøj<br />
								Telefon: <a href="tel:+4571873167">71 87 31 67</a><br />
								E-mail: <a href="mailto:alaskacykler@mail.com">alaskacykler@mail.com</a><br />
								CVR-nr.: 38971069
							</p>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default TermsConditions;



// WEBPACK FOOTER //
// ./src/Pages/TermsConditions.js